var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"lang":_vm.lang},on:{"lang-change":_vm.setLang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }